(() => {
  const THUMB_LINK = '.card__variant-thumb-link';
  const CARD_WRAPPER = '.card-wrapper';

  function storeOriginal(img) {
    if (!img || img.dataset.originalStored === '1') return;
    img.dataset.originalSrc = img.getAttribute('src') || '';
    img.dataset.originalSrcset = img.getAttribute('srcset') || '';
    img.dataset.originalAlt = img.getAttribute('alt') || '';
    img.dataset.originalStored = '1';
  }

  function setImg(img, src, srcset, alt) {
    if (!img || !src) return;
    img.setAttribute('src', src);

    if (srcset && srcset.trim().length) {
      img.setAttribute('srcset', srcset.trim());
    } else {
      img.removeAttribute('srcset');
    }

    if (alt) img.setAttribute('alt', alt);
  }

  function restoreCard(wrapper) {
    const main = wrapper.querySelector('img.js-card-main-image');
    const secondary = wrapper.querySelector('img.js-card-secondary-image');

    if (main?.dataset.originalStored === '1') {
      setImg(main, main.dataset.originalSrc, main.dataset.originalSrcset, main.dataset.originalAlt);
    }
    if (secondary?.dataset.originalStored === '1') {
      setImg(secondary, secondary.dataset.originalSrc, secondary.dataset.originalSrcset, secondary.dataset.originalAlt);
    }
  }

  // Hover sobre miniaturas -> cambia imagen grande
  document.addEventListener('mouseover', (e) => {
    const link = e.target.closest(THUMB_LINK);
    if (!link) return;

    const wrapper = link.closest(CARD_WRAPPER);
    if (!wrapper) return;

    const main = wrapper.querySelector('img.js-card-main-image');
    const secondary = wrapper.querySelector('img.js-card-secondary-image');

    storeOriginal(main);
    storeOriginal(secondary);

    const src = link.dataset.variantSrc;
    const srcset = link.dataset.variantSrcset;
    const alt = link.dataset.variantAlt;

    setImg(main, src, srcset, alt);
    // Para que el hover de la card no “salte” a otra imagen distinta
    setImg(secondary, src, srcset, alt);
  });

  // Cuando sales de la card -> vuelve a la imagen original
  document.addEventListener('mouseout', (e) => {
    const wrapper = e.target.closest(CARD_WRAPPER);
    if (!wrapper) return;

    // si todavía estás dentro de la misma card, no restaures
    if (wrapper.contains(e.relatedTarget)) return;

    restoreCard(wrapper);
  });

  // Accesibilidad: si navegas con teclado y enfocas una miniatura
  document.addEventListener('focusin', (e) => {
    const link = e.target.closest(THUMB_LINK);
    if (!link) return;

    const wrapper = link.closest(CARD_WRAPPER);
    if (!wrapper) return;

    const main = wrapper.querySelector('img.js-card-main-image');
    const secondary = wrapper.querySelector('img.js-card-secondary-image');

    storeOriginal(main);
    storeOriginal(secondary);

    setImg(main, link.dataset.variantSrc, link.dataset.variantSrcset, link.dataset.variantAlt);
    setImg(secondary, link.dataset.variantSrc, link.dataset.variantSrcset, link.dataset.variantAlt);
  });
})();
